import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../models/List.Kitchen';

@Injectable({
  providedIn: 'root'
})
export class KitchenService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/ResKitchen/GetAllKitchen`, filter);
  }
  GetDetails(id: string) {
    return this.http.get(`${environment.apiUrl}/ResKitchen/GetKitchenById?id=${id}`);
  }
  delete(id: string) {
    return this.http.post(`${environment.apiUrl}/ResKitchen/DeleteKitchen?id=${id}`, null);
  }
  saveRecord(data: any) {
    if (data.id) {
      return this.http.post(`${environment.apiUrl}/ResKitchen/EditKitchen`, data);
    } else {
      return this.http.post(`${environment.apiUrl}/ResKitchen/NewKitchen`, data);
    }
  }
  GetAllRestaurantKitchen(RestaurantId: number, HasKDS: boolean | null) {
    let params: any = { RestaurantId };
    if (HasKDS != null) {
      params.HasKDS = HasKDS;
    }
    return this.http.get(`${environment.apiUrl}/ResKitchen/GetAllRestaurantKitchen`, { params });
  }
  GetAllRestaurantKitchens(restaurantsIds: number[]) {
    return this.http.post(`${environment.apiUrl}/ResKitchen/ResGetRestaurantsKitchens`, { restaurantsIds });
  }
  GetMenuitemKitchens(KitchensId: any) {
    return this.http.post(`${environment.apiUrl}/ResKitchen/GetMenuitemKitchens?KitchensId=${KitchensId}`, null);
  }
  getStaffsKitchens(KitchensId: any) {
    return this.http.post(`${environment.apiUrl}/ResKitchen/getStaffsKitchens?KitchensId=${KitchensId}`, null);
  }
}
